import React from "react";
import {GlobalAlertContextConsumer} from "./GlobalAlertContextProvider";
import AlertBadge from "./AlertBadge";

class EventAlertBadge extends React.Component<any, any> {
  public render() {
    return (
      <GlobalAlertContextConsumer>
        {(globalAlertContextState) => {
          return (
            <AlertBadge count={globalAlertContextState.event.alertCount} />
          );
        }}
      </GlobalAlertContextConsumer>
    );
  }
}

export default EventAlertBadge;


// WEBPACK FOOTER //
// ./src/app/alert/EventAlertBadge.tsx